module.exports = __webpack_public_path__ + "static/media/engage.0d0a60ff.svg";